import { Component } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';
import { AuthProvider } from '../../providers/auth/auth';

declare let CmKit: any;

@Component({
  selector: 'account-menu-toggle',
  templateUrl: 'account-menu-toggle.html',
})
export class AccountMenuToggleComponent {
  log = debug('app:AccountMenuToggleComponent');
  authenticated = false;
  showAuthorizedUser = false;
  userInfo;
  subs: any = [];

  constructor(
    private authService: AuthProvider,
    public user: UserProvider,
    public tools: ToolsProvider
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.checkAuthenticated();
    }, 0);
    this.subs.push(
      this.authService.on('authenticated', () => {
        this.checkAuthenticated();
      })
    );
  }

  openMainDrawer() {
    setTimeout(() => {
      this.tools.emit('open-main-drawer');
    });
  }

  private checkAuthenticated() {
    this.authenticated = this.user.authenticated;
    if (this.authenticated) {
      this.userInfo = this.user.get();
    }
    if (
      this.authenticated &&
      !this.user.unauthedUser &&
      _.get(this.userInfo, '_id')
    ) {
      this.showAuthorizedUser = true;
    } else {
      this.showAuthorizedUser = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/account-menu-toggle/account-menu-toggle.ts